import React, { useCallback } from 'react';
import { TStyle, useClassnames } from '@wb-tech/ui-react';

import style from './index.module.pcss';

export interface IProps {
    className?: TStyle | string,
    presetShape?: 'round' | 'square',
    presetWidth?: string | number,
    presetHeight?: number | Array<number>
}

export const Skeleton = ({ presetShape = 'square', presetWidth = '100px', presetHeight = 24, ...props }: IProps) => {
    const cn = useClassnames(style, props.className);

    const randomIntFromInterval = useCallback((min: number, max: number) => {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }, []);

    const getPresetHeight = (): string | undefined => {
        let result;

        if(typeof presetHeight === 'number') {
            result = presetHeight;
        }

        if(typeof presetHeight === 'object' && Array.isArray(presetHeight)) {
            result = randomIntFromInterval(presetHeight[0], presetHeight[1]);
        }

        return `${result}px`;
    };

    return (
        <div
            style={{
                width : typeof presetWidth === 'number' ? `${presetWidth}px` : presetWidth,
                height: getPresetHeight()
            }}
            className={cn('skeleton', `skeleton_${presetShape}`)}
        />
    );
};
